import api from '../utils/api';

/**
 * Dashboard Service
 * All dashboard statistics API calls
 */

export const dashboardService = {
  /**
   * Get dashboard statistics
   */
  getDashboardStats: async () => {
    return api.get('/dashboard/stats');
  },

  /**
   * Get per-user news stats (paginated)
   */
  getUserNewsStats: async (params) => {
    return api.get('/dashboard/user-news-stats', { params });
  },
};
